module.exports = __webpack_public_path__ + "img/galeria-especie-exotica-10.e78a54d5.jpg";